const normalizeContent = (content = "") => content.replace(/\\n/g, "\n").replace(/\r\n/g, "\n");

const pushTextToken = (tokens, content) => {
  if (!content) return;
  const lastToken = tokens[tokens.length - 1];
  if (lastToken?.type === "text") {
    lastToken.content += content;
    return;
  }
  tokens.push({ type: "text", content });
};

const parseInlineTokens = (text = "") => {
  const tokens = [];
  let cursor = 0;

  while (cursor < text.length) {
    if (text.startsWith("`", cursor)) {
      const closingIndex = text.indexOf("`", cursor + 1);
      if (closingIndex !== -1) {
        const content = text.slice(cursor + 1, closingIndex);
        tokens.push({ type: "inlineCode", content });
        cursor = closingIndex + 1;
        continue;
      }
    }

    if (text.startsWith("**", cursor)) {
      const closingIndex = text.indexOf("**", cursor + 2);
      if (closingIndex !== -1) {
        const content = text.slice(cursor + 2, closingIndex);
        tokens.push({ type: "bold", content });
        cursor = closingIndex + 2;
        continue;
      }
    }

    if (text.startsWith("*", cursor)) {
      const closingIndex = text.indexOf("*", cursor + 1);
      if (closingIndex !== -1) {
        const content = text.slice(cursor + 1, closingIndex);
        tokens.push({ type: "italics", content });
        cursor = closingIndex + 1;
        continue;
      }
    }

    pushTextToken(tokens, text[cursor]);
    cursor += 1;
  }

  return tokens.length ? tokens : [{ type: "text", content: text }];
};

export const parseBlogContent = (content = "") => {
  const lines = normalizeContent(content).split("\n");
  const segments = [];
  let textBuffer = [];
  let codeBuffer = [];
  let inCodeBlock = false;
  let codeLanguage = "text";

  const flushText = () => {
    if (!textBuffer.length) return;

    const normalized = textBuffer.join("\n");
    const blocks = normalized
      .split(/\n\s*\n/)
      .map((block) => block.trim())
      .filter(Boolean);

    blocks.forEach((block, index) => {
      const listItems = block
        .split("\n")
        .map((line) => line.trim())
        .filter(Boolean);
      const isList = listItems.length > 0 && listItems.every((line) => /^-\s+/.test(line));

      if (isList) {
        segments.push({
          id: `list-${segments.length}-${index}`,
          type: "list",
          items: listItems.map((line) => parseInlineTokens(line.replace(/^-\s+/, ""))),
        });
        return;
      }

      segments.push({
        id: `paragraph-${segments.length}-${index}`,
        type: "paragraph",
        tokens: parseInlineTokens(block),
      });
    });

    textBuffer = [];
  };

  const flushCode = () => {
    segments.push({
      id: `code-${segments.length}`,
      type: "code",
      language: codeLanguage || "text",
      content: codeBuffer.join("\n"),
    });
    codeBuffer = [];
    codeLanguage = "text";
  };

  lines.forEach((line) => {
    const fenceMatch = line.match(/^```\s*([\w-]+)?\s*$/);

    if (fenceMatch) {
      if (inCodeBlock) {
        flushCode();
        inCodeBlock = false;
      } else {
        flushText();
        inCodeBlock = true;
        codeLanguage = fenceMatch[1] || "text";
      }
      return;
    }

    if (inCodeBlock) {
      codeBuffer.push(line);
    } else {
      textBuffer.push(line);
    }
  });

  if (inCodeBlock) flushCode();
  flushText();
  return segments;
};
